import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updatePaymentModes, updatePaymentModeFormObject } from '@store/slice/paymentSlice'
import { updateNotification, updateData } from '@store/slice/mainSlice'
import { get } from '@util/xhrAPI'
import { useTranslation } from 'react-i18next'
import useDeleteButton from '@hook/useDeleteButton'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table"
import Alert from '@ui/elements/Alert'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'
import { useNavigate } from 'react-router'
import { ROLE_ADMIN } from '@router/Routes'

const PaymentModesList = () => {
  const { paymentModes } = useSelector(state => state.payment)
  const { mission } = useSelector(state => state.main)
  const theme = useTheme(getTheme())
  const dispatch = useDispatch()
  const deleteButton = useDeleteButton()
  const [t] = useTranslation('common')
  const navigate = useNavigate()

  const dataPaymentModes = { nodes: [] }
  if (paymentModes) {
    dataPaymentModes.nodes = Object.values(paymentModes)
  }

  const removePaymentMode = paymentMode => {
    const { id, links } = paymentMode
    get(`${import.meta.env.VITE_API_URL}${links.remove}`, response => {
      const { code } = response
      if (code === 200) {
        const paymentMode = paymentModes[id]
        const paymentModesList = { ...paymentModes }
        delete paymentModesList[id]
        dispatch(updatePaymentModes({ ...paymentModesList }))
        dispatch(updateNotification({ type: 'is-success', message: t('messages.removed_successfuly', { title: paymentMode.name }) }))
      } else {
        dispatch(updateNotification({ type: 'is-danger', message: t('messages.error_occured') }))
      }
    })
  }

  const editPaymentMode = paymentMode => {
    dispatch(updatePaymentModeFormObject(paymentMode))
    navigate(ROLE_ADMIN.editPaymentMode)
  }

  useEffect(() => {
    get(`${import.meta.env.VITE_API_URL}/api/missions/${mission.id}/payment-modes`, response => {
      const { code, options, paymentModes } = response
      if (code === 200) {
        dispatch(updatePaymentModes(paymentModes))
        dispatch(updateData({ paymentModes: options }))
      }
    })
  }, [])


  return (
    <Div cssClass='payment-modes-list'>
      <Div cssClass='actions-zone'>
        <Buttons buttons={{
          icon: 'icon-add',
          cssClass: 'is-info is-small',
          callback: () => navigate(ROLE_ADMIN['editPaymentMode']),
          text: t('actions.add')
        }}
        />
      </Div>
      <h2 className='zone-title'>{t('titles.payment_modes_list')}</h2>
      {null !== paymentModes && dataPaymentModes.nodes.length
        ? <>
          <Table data={dataPaymentModes} theme={theme}>
            {(tableList) => (
              <>
                <Header>
                  <HeaderRow>
                    <HeaderCell>ID</HeaderCell>
                    <HeaderCell>{t('table.Name')}</HeaderCell>
                    <HeaderCell>{t('table.IsActive')}</HeaderCell>
                    <HeaderCell>Actions</HeaderCell>
                  </HeaderRow>
                </Header>
                <Body>
                  {tableList.map(item =>
                    <Row key={item.id} item={item}>
                      <Cell>{item.id}</Cell>
                      <Cell>{item.name}</Cell>
                      <Cell>{item.isActive ? t('labels.yes') : t('labels.no')}</Cell>
                      <Cell className='table-actions'>
                        <Buttons buttons={[
                          {
                            icon: 'icon-create',
                            cssClass: 'is-info is-small',
                            callback: () => editPaymentMode(item)
                          }
                        ]} />
                        {deleteButton(item, item.name, removePaymentMode)}
                      </Cell>
                    </Row>
                  )}
                </Body>
              </>
            )}
          </Table>
        </>
        : <Alert type='is-info' message={t('messages.empty_list')} />
      }
    </Div>
  )
}

export default PaymentModesList